module.exports = new __parcel__URL__("companyLogo.585eaf7c.jpg").toString();